import { Component } from '@angular/core';
import { JourneyPdfPreviewComponent } from '../journey-pdf-preview/journey-pdf-preview.component';

@Component({
    selector: 'rn-journey-pdf-expand-preview',
    templateUrl: './journey-pdf-expand-preview.component.html',
    styleUrls: ['./journey-pdf-expand-preview.component.scss'],
    standalone: true,
    imports: [JourneyPdfPreviewComponent]
})
export class JourneyPdfExpandPreviewComponent {}
